@if (authService.hasPermission(Permission.ProductsSummaryStatus)) {
  <div
    class="status-text"
    [ngClass]="{
      complete:
        product.releasedInCollection &&
        product.approvedOutputAssetCount === product.expectedOutputAssetCount &&
        product.expectedOutputAssetCount > 0,
    }"
  >
    <div class="external-status"></div>
    {{
      product.releasedInCollection &&
      product.approvedOutputAssetCount === product.expectedOutputAssetCount &&
      product.expectedOutputAssetCount > 0
        ? "Complete"
        : "Pending"
    }}
  </div>
}
